

import React from 'react';
import exact from 'prop-types-exact';
import { useParams } from 'react-router-dom';
import Top10App from '../../components/top10/index';
import { getTop10DataIfNeeded } from '../../components/top10/actions/Top10Actions';

const As10Mais = () => {
    const { slug } = useParams();

    return (
        <div className="pageWrapper tw-container tw-m-auto tw-px-5">
            <Top10App withCategory slug={slug} />
        </div>
    );
};

As10Mais.fetchData = (store, match) => store.dispatch(getTop10DataIfNeeded(match.params.slug));

As10Mais.propTypes = exact({});

export default As10Mais;
